module.exports = __webpack_public_path__ + "img/Code Version Control.e1c61076.svg";